var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',{attrs:{"shadow":"false","header":"QUERY ID"}},[_c('div',{staticClass:"box"},[_vm._v(" "+_vm._s(_vm.detail.queryid)+" ")]),_c('customize-button',{staticStyle:{"margin-top":"20px"},attrs:{"type":"primary"},on:{"click":_vm.handleSubmit}},[_vm._v(" Submit ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }